import { hqAnnualPolicyDraftSchema, hqAnnualPolicyLoadResultSchema, hqAnnualPolicySaveResultSchema, type HqAnnualPolicyDraft } from '@kop/contracts';

export interface AnnualPolicyTransport {
  loadAnnual(input: { year: number }): Promise<unknown>;
  saveAnnual(input: { commandId: string; expectedVersion: number; draft: HqAnnualPolicyDraft }): Promise<unknown>;
}
export function createAnnualPolicyRepository(transport: AnnualPolicyTransport) {
  return {
    async load(year: number) {
      const result = hqAnnualPolicyLoadResultSchema.parse(await transport.loadAnnual({ year }));
      if (result.document && (result.document.year !== year || result.document.draft.year !== year)) throw Error('POLICY_YEAR_MISMATCH');
      return result;
    },
    async save(command: { commandId: string; expectedVersion: number; draft: HqAnnualPolicyDraft }) {
      const draft = hqAnnualPolicyDraftSchema.parse(command.draft);
      const result = hqAnnualPolicySaveResultSchema.parse(await transport.saveAnnual({ ...command, draft }));
      if (result.receipt.commandId !== command.commandId || result.receipt.version !== result.document.version ||
          result.document.version !== command.expectedVersion + 1 || result.document.year !== draft.year ||
          result.receipt.savedAt !== result.document.savedAt || JSON.stringify(result.document.draft) !== JSON.stringify(draft)) throw Error('POLICY_RECEIPT_MISMATCH');
      return result;
    },
  };
}
export function createFirebaseAnnualPolicyRepository() {
  const config = {
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '', apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '', authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    appCheckSiteKey: import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY ?? '',
  };
  if (import.meta.env.VITE_AUTH_ADAPTER !== 'firebase' || Object.values(config).some(value => !value.trim())) return null;
  const port = import('@kop/operations-firebase-adapter').then(module => module.createHqHalfyearReviewPort(config));
  return createAnnualPolicyRepository({ loadAnnual: async input => (await port).loadAnnual(input), saveAnnual: async input => (await port).saveAnnual(input) });
}
export type AnnualPolicyRepository = ReturnType<typeof createAnnualPolicyRepository>;
